import React, { useState } from "react";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { toggleButton } from "../../../../../utils/componentutils/ToggleButton";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Box, makeStyles } from "@material-ui/core";
import TreeItem from "@material-ui/lab/TreeItem";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import { CreateTacticTextField } from "./CreateTradePlanTree";

const optionChainStrategies = ["hugCurrentPrice"];
var firstCheck = true;
var currentValue = false;

const useStyles = makeStyles({
  root: {
    //height: 216,
    //flexGrow: 1,
    //maxWidth: 400,
  },
  expanded: {
    color: "green",
  },
});

const boxProps = {
  bgcolor: "background.paper",
  m: 1,
  borderColor: "text.primary",
};

let hugCurrentPriceId = "hugCurrentPrice";
let otm1Id = "otm1";
const OptionChainStrategyTree = (props) => {
  const classes = useStyles();
  var [expanded, setExpanded] = useState([]);
  var [selected, setSelected] = useState([]);
  var [seeOptionChainStrategies, setSeeOptionChainStrategies] = useState(true);
  const hugCurrentPriceEnabled = props.hugCurrentPriceEnabled;
  const setHugCurrentPriceEnabled = props.setHugCurrentPriceEnabled;
  const dispatchHugCurrentPrice = props.dispatchHugCurrentPrice;
  const hugCurrentPrice = props.hugCurrentPrice;

  const otm1Enabled = props.otm1Enabled;
  const setOtm1Enabled = props.setOtm1Enabled;
  const otm1 = props.otm1;
  const dispatchOtm1 = props.dispatchOtm1;
  //console.log(expanded);
  //console.log(selected);
  if (seeOptionChainStrategies) {
    expanded.push("optionChainStrategies");
    selected.push("optionChainStrategies");
  }
  if (hugCurrentPriceEnabled) {
    expanded.push(hugCurrentPriceId);
  }
  if (otm1Enabled) {
    selected.push(hugCurrentPriceId);
  }

  const optionChainStrategies = {};
  optionChainStrategies["optionChainStrategies"] = [
    seeOptionChainStrategies,
    setSeeOptionChainStrategies,
  ];

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  const handleSelect = (event, nodeId) => {
    if (optionChainStrategies[nodeId] !== undefined) {
      let [
        enableOptionChainStrategy,
        setEnableOptionChainStrategy,
      ] = optionChainStrategies[nodeId];
      setEnableOptionChainStrategy(toggleButton(enableOptionChainStrategy));
      selected.push(nodeId);
      setSelected(selected);
    }
  };

  return (
    <div>
      <TreeView
        className={classes.root}
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        expanded={expanded}
        selected={selected}
        onNodeToggle={handleToggle}
        onNodeSelect={handleSelect}
      >
        <TreeItem
          nodeId="optionChainStrategies"
          label={
            <Typography style={{ fontSize: 15 }}>
              optionChain strategies
            </Typography>
          }
        >
          <TreeItem
            nodeId={hugCurrentPriceId}
            collapseIcon={<CheckBoxIcon />}
            expandIcon={<CheckBoxOutlineBlankIcon />}
            classes={{ expanded: classes.expanded }}
            label={
              <Typography style={{ fontSize: 12 }}>
                hug current price
              </Typography>
            }
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems="stretch"
              border={1}
              {...boxProps}
            >
              <CreateTacticTextField
                label="# of strikes"
                defaultValue={
                  hugCurrentPrice !== undefined
                    ? hugCurrentPrice.numOfStrikes
                    : 0
                }
                onBlurFunc={(ev) =>
                  dispatchHugCurrentPrice({ numOfStrikes: ev.target.value })
                }
              />
            </Box>
          </TreeItem>
          <TreeItem
            nodeId={otm1Id}
            collapseIcon={<CheckBoxIcon />}
            expandIcon={<CheckBoxOutlineBlankIcon />}
            classes={{ expanded: classes.expanded }}
            label={<Typography style={{ fontSize: 12 }}>OTM1</Typography>}
          />
        </TreeItem>
      </TreeView>
    </div>
  );
};
export default OptionChainStrategyTree;
